export default "__VITE_PUBLIC_ASSET__0b3ec86a__"